import React from 'react';
import { Box, Typography } from '@mui/material';
import { adminBottomBannerSx } from '../../../../styles/adminComponentStyles';
import type { AgentConfigurationLastSeenBannerProps } from '../../../../types/features/storeDetails/agentConfigurationCard';
import { getNextPingLabel } from '../../overview/utils/formatters/agentHeartbeatFormatter';

const AgentConfigurationLastSeenBanner: React.FC<AgentConfigurationLastSeenBannerProps> = ({
  lastSeenAt,
  lastSeenLabel,
  heartbeatIntervalMinutes,
}) => {
  const [nowMs, setNowMs] = React.useState(() => Date.now());

  React.useEffect(() => {
    setNowMs(Date.now());
    const intervalId = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(intervalId);
  }, [heartbeatIntervalMinutes, lastSeenAt]);

  const nextPingLabel = getNextPingLabel(lastSeenAt, heartbeatIntervalMinutes, nowMs);

  return (
    <Box
      sx={{
        ...adminBottomBannerSx,
        textAlign: 'left',
        '& span.last-seen-value': {
          color: '#2c6ca0',
          fontWeight: 600,
        },
        '& span.next-ping-value': {
          color: nextPingLabel === 'Overdue' ? '#c62828' : '#2c6ca0',
          fontWeight: 600,
        },
      }}
    >
      <Typography
        variant="caption"
        className="AdminBottomBanner-text"
      >
        <span className="last-seen-dot" style={{ display: 'inline-block', height: '8px', width: '8px', background: '#66b005', borderRadius: '50%' }} /> Last Seen: <span className="last-seen-value">{lastSeenLabel}</span>
        {nextPingLabel === 'Overdue' ? (
          <> · <span className="next-ping-value">Overdue</span></>
        ) : nextPingLabel ? (
          <> · Next ping in <span className="next-ping-value">{nextPingLabel}</span></>
        ) : null}
      </Typography>
    </Box>
  );
};

export default React.memo(AgentConfigurationLastSeenBanner);
